import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { pageEventSection, pageManageSection } from "./urls";
import PageEventListComponent from "./views/PageEvents";
import PageManageComponent from "./views/PageManage";
const PageEventList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  return <PageEventListComponent params={qs} />;
};
const PageManage: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  return <PageManageComponent params={qs} />;
};
const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.pageManage)} />
      <Switch>
        <Route exact path={pageManageSection} component={PageManage} />
        <Route path={pageEventSection} component={PageEventList} />
      </Switch>
    </>
  );
};
export default Component;
